import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Twitter censoring the WikiLeaks debate?",
  "description": "",
  "published": "2010-12-05T00:00:00.000Z",
  "redirect_from": ["/blog/twitter-censoring-the-wikileaks-debate/swizec/1519"],
  "categories": "Amazon, PayPal, Twitter, Uncategorized, Wikileaks",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Back in the good old days of social media ... early last year ... twitter was seen as a bit of a bad boy on the block. They didn't conform to anyone and when Iran made damn sure to censor the protests following the election into oblivion, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Twitter",
        "title": "Twitter"
      }}>{`Twitter`}</a>{` stood tall and proud letting people communicate and even coordinate the protests.`}</p>
    <p>{`This year, when something even bigger and more important is happening ... Twitter doesn't seem to be quite as happy about it.`}</p>
    <p>{`Now, they may not be doing anything too horrible. Yes, you can still tweet the word `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wikileaks",
        "title": "Wikileaks"
      }}>{`WikiLeaks`}</a>{`, yes there's only a small chance you're on everyone's watchlist already because you googled wikileaks or whatever.`}</p>
    <p>{`But it would seem that for whatever reason WikiLeaks is not a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Trending_topic",
        "title": "Trending topic"
      }}>{`trending topic`}</a>{`.`}</p>
    <p>{`So I made a little experiment. I clicked on the lowest trending topic of Kevin Hart and I made a search for WikiLeaks. Then I left both tabs open for 4 minutes.`}</p>
    <p>{`The final tally? Kevin Hart, 3 tweets. WikiLeaks, 55 tweets.`}</p>
    <p>{`Now I'm not sure what exactly is going on here, but it seems to be Twitter's little contribution to everybody in the US censoring the whole WikiLeaks thing. Perhaps not quite on the same level as Amazon denying `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Domain_Name_System",
        "title": "Domain Name System"
      }}>{`DNS`}</a>{` services and PayPal suspending their account ... but it's still something.`}</p>
    <p>{`What really bothers me though is that everyone is trying so fucking damn hard to censor this thing, but when it's about a different country and their shameful things. Meh, nobody cares.`}</p>
    <p>{`Is WikiLeaks going to become America's Tiananmen Square?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2010/12/05/wikileaks-twitter-twikileaks/"
        }}>{`Why Is The WikiLeaks Twitter Account Only Following TweetBackup?`}</a>{` (techcrunch.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.huffingtonpost.com/2010/12/04/watch-what-you-tweet-abou_n_792085.html"
        }}>{`Watch What You Tweet About WikiLeaks: Twitter Reacts`}</a>{` (huffingtonpost.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ibnlive.in.com/news/wikileaks-domain-killed-by-us/136407-11.html?from=tn"
        }}>{`WikiLeaks domain 'killed by US'`}</a>{` (ibnlive.in.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://yro.slashdot.org/story/10/12/04/229233/WikiLeaks-Starts-Mass-Mirroring-Effort"
        }}>{`WikiLeaks Starts Mass Mirroring Effort`}</a>{` (yro.slashdot.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//thelede.blogs.nytimes.com/2010/12/04/paypal-suspends-wikileaks-account/&a=29713202&rid=23f18b51-292f-4c0d-b886-95fe8293df66&e=244331d7785c842ed75b6af880961744"
        }}>{`PayPal Suspends WikiLeaks Account`}</a>{` (thelede.blogs.nytimes.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=23f18b51-292f-4c0d-b886-95fe8293df66",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      